// material-ui
import {useTheme} from '@mui/material/styles';
import config from '../config';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
  const theme = useTheme(); // eslint-disable-line

  return (
    /**
     * if you want to use image instead of svg uncomment following, and comment out <svg> element.
     *
     * <img src={logo} alt="Berry" width="100" />
     *
     */
    <h1>{config.name}</h1>
  //    style={{ fontSize:"24px"}}>Graphics Admin
  );
};

export default Logo;